import "./App.css";
import CollapsibleExample from "./navbar";
import Privacy from "./privacy";

function App() {
  return (
    <>
      <CollapsibleExample />
      <Privacy />
    </>
  );
}

export default App;
